import { Component, OnInit } from "@angular/core";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-attribute",
  templateUrl: "./attribute.component.html",
  styleUrls: ["./attribute.component.scss"],
})
export class AttributeComponent implements OnInit {
  dataSource: any;
  attributeList: any;
  entity: any;
  private paginator: MatPaginator;
  // tslint:disable-next-line: variable-name
  public created_By: any;
  displayedColumns: string[] = ["entity", "name", "edit", "delete"];
  public validator = {
    errorMessage: "",
    UniqueAttribute: false,
  };
  public shown = {
    grid: false,
    Form: true,
  };

  public attributeEdit = {
    edit: false,
  };
  isShowInfos: any;

  Attribute = new FormGroup({
    attributeId: new FormControl(),
    name: new FormControl(),
    uiName: new FormControl(),
    entityType: new FormControl(),
    dataType: new FormControl(),
    isShowInfo: new FormControl(),
    isShowAlgo: new FormControl(),
    isUnique: new FormControl(),
    isCustom: new FormControl(),
    correlationValue: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
  }
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    private router: Router,
    private daoService: DaoService,
    private fb: UntypedFormBuilder,
    private token: LstorageService,
    private spinner: SpinnerService
  ) {
    this.spinner.show();
    this.daoService.getAttributeList().subscribe(
      (data: any) => {
        this.attributeList = data;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource(this.attributeList);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        this.spinner.hide();
        console.log("Error: " + error);
      }
    );
    // this.daoService.getEntity().subscribe((data) => {
    //   this.entity = data;
    // });
    this.daoService.getEntities().subscribe((data) => {
      this.entity = data;
    });
  }
  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Attribute = this.fb.group({
      attributeId: [""],
      name: [""],
      uiName: [""],
      entityType: [this.token.getEntityName(), [Validators.required]],
      dataType: ["1001"],
      isShowInfo: [false],
      isShowAlgo: [false],
      isUnique: [false],
      isCustom: [false],
      correlationValue: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-11-05T17:04:56.351Z"],
      modifiedBy: [""],
      modifiedOn: ["2019-11-05T17:35:10.052Z"],
    });
  }

  setDataSourceAttributes() {
    this.setDataSourceAttributes();
    this.dataSource.paginator = this.paginator;
  }

  // Form
  AttributeForm() {
    this.attributeEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Attribute = this.fb.group({
      attributeId: [""],
      uiName: [""],
      name: [""],
      entityType: [""],
      dataType: ["1001"],
      isShowInfo: [false],
      isShowAlgo: [false],
      isUnique: [false],
      isCustom: [false],
      correlationValue: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-11-05T17:04:56.351Z"],
      modifiedBy: [""],
      modifiedOn: ["2019-11-05T17:35:10.052Z"],
    });
  }

  createAttribute() {
    this.validator.UniqueAttribute = false;
    this.daoService.AddAttribute(this.Attribute.value).subscribe(
      (data: any) => {
        this.backattributeList();
      },
      (error) => {
        console.log(error);
        this.validator.UniqueAttribute = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }
  editAttribute(id) {
    this.shown.grid = false;
    this.shown.Form = true;
    this.attributeEdit.edit = true;
    this.daoService.getAttributeById(id).subscribe((data: any) => {
      this.Attribute = this.fb.group({
        attributeId: [id],
        entityType: [data.entityType, [Validators.required]],
        name: [data.name, [Validators.required]],
        uiName: [data.uiName, [Validators.required]],
        isShowInfo: [data.isShowInfo, [Validators.required]],
        isShowAlgo: [data.isShowAlgo, [Validators.required]],
        isUnique: [data.isUnique, [Validators.required]],
        isCustom: [data.isCustom, [Validators.required]],
        correlationValue: [data.correlationValue, [Validators.required]],
        modifiedBy: [this.created_By.unique_name],
      });
    });
  }

  deleteAttribute(id, index) {
    this.daoService.deleteAttributeById(id).subscribe((data: any) => {
      this.attributeList = this.removeFromArrayOfHash(
        this.attributeList,
        "attributeId",
        data.data.attributeId
      );
      this.dataSource = new MatTableDataSource(this.attributeList);
      this.dataSource.paginator = this.paginator;
    });
  }
  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  backattributeList() {
    //    this.shown.grid = true;
    //    this.shown.Form = false;
    //    this.validator.UniqueAttribute = false;
    //    this.daoService.getAttributeList().subscribe((data: any) => {
    //      this.attributeList = data;
    //      this.dataSource = new MatTableDataSource(this.attributeList);
    //      this.dataSource.paginator = this.paginator;
    //    });

    this.router.navigate(["/apiManager"]);
  }
}
